export const sendEvent = (eventType, eventProperties) => {
  if (typeof window !== undefined && window.amplitude) {
    window.amplitude.getInstance().logEvent(eventType, eventProperties);
  }
};
